const movies = [
  {
    id: "1",
    poster: "https://i.ibb.co/3rQ1Zgt/movie2.png",
    title: "Dune",
    release_date: "March 23, 2024",
    genre: ["Drama", "Sci-Fi", "Futuristic"],
    duration: "1hr 43mins",
    language: ["English", "French"],
  },
  {
    id: "2",
    poster: "https://i.ibb.co/d74wnHS/crakkpost.png",
    title: "Crakk",
    release_date: "December 3, 2026",
    genre: ["Sci-Fi", "Adventure", "Fiction"],
    duration: "2hr",
    language: ["English"],
  },
  {
    id: "3",
    poster: "https://i.ibb.co/qFhZH8M/purplepost.png",
    title: "The Color Purple",
    release_date: "January 1, 2024",
    genre: ["Drama", "Comedy"],
    duration: "1hr 26mins",
    language: ["English"],
  },
  {
    id: "4",
    poster: "https://i.ibb.co/kS1NFQV/banner.png",
    title: "The Joker 2",
    release_date: "May 23, 2024",
    genre: ["Fiction", "Futuristic"],
    duration: "2hr 3mins",
    language: ["English", "French", "Spanish"],
  },
  {
    id: "5",
    poster: "https://i.ibb.co/KXwMDyj/banner2.png",
    title: "The Joker",
    release_date: "March 23, 2021",
    genre: ["Fiction", "Dark"],
    duration: "1hr 43mins",
    language: ["English", "French"],
  },
  {
    id: "6",
    poster: "https://i.ibb.co/MPF4BrG/bob-marleypost.jpg",
    title: "One Love",
    release_date: "December 3, 2026",
    genre: ["Sci-Fi", "Adventure", "Fiction"],
    duration: "2hr",
    language: ["English"],
  },
  {
    id: "7",
    poster: "https://i.ibb.co/Ld9Cj5P/madamepost.png",
    title: "Madame Web",
    release_date: "January 1, 2024",
    genre: ["Drama", "Comedy"],
    duration: "1hr 26mins",
    language: ["English"],
  },
  {
    id: "8",
    poster: "https://i.ibb.co/3rQ1Zgt/movie2.png",
    title: "Dune",
    release_date: "March 23, 2024",
    genre: ["Drama", "Sci-Fi", "Futuristic"],
    duration: "1hr 43mins",
    language: ["English", "French"],
  },
  {
    id: "9",
    poster: "https://i.ibb.co/d74wnHS/crakkpost.png",
    title: "Crakk",
    release_date: "December 3, 2026",
    genre: ["Sci-Fi", "Adventure", "Fiction"],
    duration: "2hr",
    language: ["English"],
  },
  {
    id: "10",
    poster: "https://i.ibb.co/qFhZH8M/purplepost.png",
    title: "The Color Purple",
    release_date: "January 1, 2024",
    genre: ["Drama", "Comedy"],
    duration: "1hr 26mins",
    language: ["English"],
  },
];
// https://i.ibb.co/3rQ1Zgt/movie2.png
// https://i.ibb.co/KXwMDyj/banner2.png
// https://i.ibb.co/d74wnHS/crakkpost.png
// https://i.ibb.co/MPF4BrG/bob-marleypost.jpg
// https://i.ibb.co/Ld9Cj5P/madamepost.png
// https://i.ibb.co/qFhZH8M/purplepost.png
//<img src="https://i.ibb.co/kS1NFQV/banner.png" alt="banner" border="0">
export default movies;
